import React from 'react';
import Router from './routes/public.routes';

import { AuthProvider } from './hooks/auth';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
// import 'semantic-ui-css/semantic.min.css'

import './assets/styles/global.css';

function App() {
  return (
    <AuthProvider>
      <Router />
      <ToastContainer />
    </AuthProvider>
  );
}

export default App;
